var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGotcha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8092 20H1.69077C0.758505 20 0 19.2433 0 18.3133V1.68667C0 0.756667 0.758505 0 1.69077 0H14.8092C15.7415 0 16.5 0.756667 16.5 1.68667V18.3133C16.5 19.2433 15.7448 20 14.8092 20Z",
    fill: "#2EC5CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7027 13.9821V16.7721C14.7027 17.5421 14.0979 18.1654 13.3528 18.1654H2.8807C2.13556 18.1654 1.53076 17.5421 1.53076 16.7721V3.05544C1.53076 2.28544 2.13556 1.66211 2.8807 1.66211H4.22396",
    stroke: "#F4F5F7",
    strokeWidth: 0.3125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7021 10.8315V13.1649",
    stroke: "#F4F5F7",
    strokeWidth: 0.3125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7021 8.83154V10.0282",
    stroke: "#F4F5F7",
    strokeWidth: 0.3125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23975 1.66211H11.3713",
    stroke: "#F4F5F7",
    strokeWidth: 0.3125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16472 5.6665C6.33957 5.6665 5.50304 6.97686 5.35094 8.09731C5.33193 8.24923 5.36996 8.38217 5.46502 8.49611C5.56008 8.61006 5.71217 8.66703 5.84526 8.66703H6.49167C6.73882 8.66703 6.94795 8.49611 6.98598 8.24923C7.06203 7.81245 7.3282 7.2997 8.16472 7.2997C8.81113 7.2997 9.0773 7.64153 9.19137 7.83144C9.34347 8.13529 9.32446 8.45813 9.13434 8.70501C8.94422 8.97088 8.7541 9.10381 8.54497 9.23675C7.99362 9.61656 7.53733 10.0344 7.44227 11.1738C7.42326 11.3067 7.48029 11.4587 7.57535 11.5536C7.67041 11.6486 7.8035 11.7245 7.95559 11.7245H8.58299C8.84916 11.7245 9.05829 11.5156 9.0773 11.2687C9.11533 10.851 9.21039 10.775 9.47655 10.5851C9.74272 10.3952 10.0849 10.1483 10.4462 9.67353C10.9975 8.9329 11.0736 7.92639 10.6363 7.07181C10.18 6.21723 9.24841 5.6665 8.16472 5.6665Z",
    fill: "#F4F5F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24061 14.3833C8.77611 14.3833 9.21022 13.9497 9.21022 13.4148C9.21022 12.8799 8.77611 12.4463 8.24061 12.4463C7.70511 12.4463 7.271 12.8799 7.271 13.4148C7.271 13.9497 7.70511 14.3833 8.24061 14.3833Z",
    fill: "#F4F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotcha);
export default __webpack_public_path__ + "static/media/Gotcha.ab42196986dabe1e378e430d26c212ef.svg";
export { ForwardRef as ReactComponent };